var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21927_203719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3387 13.6412H26.841L20.0909 33.6527C20.0564 33.7549 20.0062 33.8511 19.942 33.9378C19.878 34.0246 19.8008 34.1007 19.7132 34.1636C19.6256 34.2265 19.5289 34.2754 19.4262 34.3084C19.3234 34.3413 19.2163 34.3584 19.1086 34.3584H14.0482C13.8839 34.3584 13.7219 34.3194 13.5757 34.2441C13.4294 34.1691 13.3031 34.0602 13.2073 33.9266C13.1115 33.7929 13.0488 33.6384 13.0244 33.4758C13 33.3132 13.0148 33.147 13.0673 32.9912L19.3561 14.3463C19.3905 14.2441 19.4407 14.148 19.505 14.0612C19.569 13.9744 19.6465 13.8983 19.7338 13.8354C19.8214 13.7725 19.9181 13.7236 20.0209 13.6906C20.1236 13.6577 20.2307 13.6406 20.3384 13.6406V13.6409L20.3387 13.6412Z",
    fill: "url(#paint0_linear_21927_203719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3254 34.359H26.4867C26.4216 34.359 26.3565 34.3529 26.2923 34.3406C26.2282 34.3285 26.1653 34.3103 26.1046 34.2865C26.0439 34.2626 25.9857 34.2329 25.9305 34.1983C25.8753 34.1634 25.8236 34.1235 25.7758 34.0791L19.1502 27.8913C19.0801 27.8258 19.0313 27.7409 19.0101 27.6474C18.9889 27.5538 18.9964 27.4561 19.0315 27.3669C19.0666 27.2777 19.1278 27.2011 19.2071 27.1471C19.2864 27.0933 19.3801 27.0645 19.476 27.0645H29.7869L32.3248 34.3592L32.3254 34.359Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8643 13.6426L22.3126 27.0666L29.7497 27.065L32.3008 34.3598H26.4842C26.424 34.3592 26.3638 34.3537 26.3045 34.343C26.2452 34.3323 26.1869 34.3167 26.1304 34.2958C26.0169 34.2544 25.9113 34.194 25.8183 34.117L21.3457 29.9427L20.0937 33.6351C20.0612 33.7274 20.0167 33.8151 19.9613 33.8956C19.85 34.0575 19.6979 34.187 19.5204 34.2711C19.432 34.3129 19.3384 34.3427 19.2421 34.3598H14.0512C13.8853 34.3603 13.7216 34.3208 13.5741 34.2444C13.4265 34.1681 13.2995 34.0574 13.2038 33.9217C13.1081 33.7859 13.0465 33.6291 13.0241 33.4646C13.0019 33.2999 13.0195 33.1323 13.0755 32.9759L19.3542 14.3617C19.3869 14.2576 19.436 14.1596 19.4998 14.0711C19.5632 13.9827 19.6407 13.9046 19.7286 13.8404C19.8165 13.7761 19.9143 13.7261 20.0178 13.6926C20.1214 13.6591 20.2299 13.642 20.339 13.6426H26.8646H26.8643Z",
    fill: "url(#paint1_linear_21927_203719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9327 32.9926C34.9852 33.1485 35 33.3145 34.9758 33.4772C34.9514 33.6398 34.8888 33.7942 34.7932 33.928C34.6974 34.0615 34.5711 34.1703 34.4249 34.2454C34.2787 34.3205 34.1167 34.3597 33.9523 34.3598H26.7053C26.8696 34.3598 27.0317 34.3205 27.1781 34.2455C27.3242 34.1705 27.4506 34.0615 27.5464 33.928C27.6423 33.7945 27.7049 33.6398 27.7294 33.4772C27.7538 33.3146 27.739 33.1484 27.6865 32.9926L21.3974 14.3472C21.3282 14.1418 21.1963 13.9633 21.0203 13.8368C20.9329 13.7739 20.8362 13.7253 20.7337 13.6923C20.6313 13.6593 20.5242 13.6426 20.4167 13.6426H27.6635C27.7711 13.6426 27.878 13.6593 27.9807 13.6923C28.0832 13.7253 28.1799 13.7742 28.2675 13.8368C28.3549 13.8997 28.4321 13.9758 28.4961 14.0623C28.5601 14.1488 28.6101 14.245 28.6447 14.3472L34.9338 32.9926H34.9327Z",
    fill: "url(#paint2_linear_21927_203719)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21927_203719",
    x1: 22.7118,
    y1: 15.1767,
    x2: 15.9543,
    y2: 35.1388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21927_203719",
    x1: 24.8187,
    y1: 24.4793,
    x2: 23.2557,
    y2: 25.0095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21927_203719",
    x1: 23.9562,
    y1: 14.5958,
    x2: 31.3729,
    y2: 34.3546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21927_203719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20.7592,
    fill: "white",
    transform: "translate(13 13.6211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/Azure.e19b04635d0428809b898ffb78124636.svg";
export { ForwardRef as ReactComponent };